import { render, staticRenderFns } from "./FBA.vue?vue&type=template&id=c1c3e8a0&scoped=true"
import script from "./FBA.vue?vue&type=script&lang=js"
export * from "./FBA.vue?vue&type=script&lang=js"
import style0 from "./FBA.vue?vue&type=style&index=0&id=c1c3e8a0&prod&scoped=true&lang=css"
import style1 from "./FBA.vue?vue&type=style&index=1&id=c1c3e8a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c3e8a0",
  null
  
)

export default component.exports